import React from 'react';
import { Reveal } from './Reveal';
import { stats } from '../data/content';
export function StatsBar() {
  return <section aria-label="Håndboldklar i tal" className="w-full bg-navy px-5 py-14 sm:py-16" data-id="element-198" data-mp="1tbjitu4bq6fx">
      <div className="mx-auto grid w-full max-w-[1120px] grid-cols-2 gap-x-6 gap-y-12 md:grid-cols-4 md:gap-x-8" data-id="element-199" data-mp="1oac8poepkv63">
        {stats.map((stat, index) => <Reveal key={stat.label} delay={index * 0.06} data-id="element-200" data-mp="1jeoh72cr7pxf" data-mpi={index}>
            <div className="flex h-full flex-col items-center text-center" data-id="element-201" data-mp="1ee0tapjtnp7f">
              <p className="font-serif text-5xl font-normal not-italic leading-none text-gold sm:text-6xl" data-id="element-202" data-mp="19m90e8d717e4">
                {stat.value}
              </p>
              <p className="mt-4 text-[11px] font-semibold uppercase leading-snug tracking-[0.16em] text-white" data-id="element-203" data-mp="15it3dax7p50w">
                {stat.label}
              </p>
            </div>
          </Reveal>)}
      </div>
    </section>;
}